import React from 'react';
import { Flex } from '..';

export default function Column({ children, style = {}, ...rest }) {
  return (
    <Flex
      style={[
        {
          flexDirection: 'column',
          flexGrow: style.width ? 0 : 1,
        },
        style,
      ]}
      {...rest}
    >
      {children}
    </Flex>
  );
}
